import HoverReveal from '../classes/hoverReveal.js';

const DEFAULTS = {
  // Selector used to find the observable children
  attrSelector: 'data-hover-share',
  direction: 'fromTop',
};

/**
 * Provides methods for setting urls within a share menu
 *
 * HoverReveal provides show/hide on hover functionality,
 * HoverShare sets default options and allows share links to be updated.
 */
export default class HoverShare extends HoverReveal {
  constructor(faqSectionEl, options = DEFAULTS) {
    super(faqSectionEl, options);
    this.options = {...DEFAULTS, ...options};

    this.facebookLink = this.el.querySelector(`[${this.options.attrSelector}-facebook]`);
    this.twitterLink = this.el.querySelector(`[${this.options.attrSelector}-twitter]`);
    this.canonicalLink = this.el.querySelector(`[${this.options.attrSelector}-canonical]`);
  }

  setFacebookUrl(url) {
    this.facebookLink.href = url;
  }

  setTwitterUrl(url) {
    this.twitterLink.href = url;
  }

  setCanonicalUrl(url) {
    this.canonicalLink.href = url;
  }

  setAllUrls(facebookUrl, twitterUrl, canonicalUrl) {
    this.setFacebookUrl(facebookUrl);
    this.setTwitterUrl(twitterUrl);
    this.setCanonicalUrl(canonicalUrl);
  }
}
